import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';
import { MuiCustomizedStyles } from "../generic/muiTable/MuiCustomizedStyles";

const theme = createTheme({
  spacing: 4,
  palette: {
    mode: "light",
    primary: {
      main: "#2340B0"
    },
    secondary: {
      main: "#3F4F6B"
    },
    error: {
      main: red.A400
    },
    background: {
      paper: "#E0F2F1",
      default: "#F1F8F6"
    },
    text: {
      primary: "#263238",
      secondary: "#4F6F69"
    }
  },
  typography: {
    fontFamily: `"Montserrat", "Helvetica", "Arial", sans-serif`,
    h1: { fontSize: "2.2rem", fontWeight: 700, letterSpacing: "0.5px" },
    h2: { fontSize: "1.8rem", fontWeight: 600, letterSpacing: "0.4px" },
    h3: { fontSize: "1.6rem", fontWeight: 600, letterSpacing: "0.3px" },
    body1: { fontSize: "1rem", fontWeight: 400, lineHeight: 1.6 },
    body2: { fontSize: "0.95rem", fontWeight: 400, lineHeight: 1.5 },
    button: {
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: "1px"
    }
  },
  shape: {
    borderRadius: 12
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: "none",
          fontWeight: 600,
          letterSpacing: "0.04em"
        },
        contained: {
          backgroundColor: "transparent",
          boxShadow: "none",
          border: `1.5px solid #2340B0`,
          color: "#2340B0",
          "&:hover": {
            backgroundColor: "rgba(35, 64, 176, 0.08)",
            boxShadow: "none"
          }
        },
        outlined: {
          borderWidth: 1.5
        }
      }
    }
  }
});

export default theme;
